import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const eaganOptions: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const eaganEmergencyDescription =
  "The Chicago Passport Agency at 230 S Dearborn St Suite 380 is approximately 400 miles southeast of Eagan — a 6+ hour drive via I-90. Minnesota has NO passport agency within state borders. Thomson Reuters global headquarters is here in Eagan — legal and financial professionals with last-minute international travel to London, Toronto, or Hong Kong cannot gamble on a 12-hour round-trip drive to Chicago. During winter (November–April), lake-effect snow squalls, black ice, and whiteout conditions on I-90 and I-94 routinely turn already-long drives into dangerous multi-day ordeals. Blue Cross Blue Shield executives with same-day flights to Zurich and Capella University faculty bound for academic conferences face zero in-state passport agency options. Winter in Minnesota is not a season — it is five months of potential highway closures between you and the nearest passport agency in Chicago.";

const eaganDisclaimer =
  "Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. Nearest agency: Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 400 miles southeast of Eagan.";

export default function EaganProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Eagan"
      headingExtra="MN"
      introText="Eagan travelers — Thomson Reuters professionals, Blue Cross Blue Shield executives, Capella University faculty, and Dakota County families — have several options for getting a passport fast. Here is how they compare, and why most Eagan residents choose a U.S. Department of State registered passport courier for predictable, professional processing."
      options={eaganOptions}
      emergencyDescription={eaganEmergencyDescription}
      disclaimerText={eaganDisclaimer}
    />
  );
}